// import fetch from '@/plugins/fetch.js'
// const url = `//svsfk.czj100.com/svsfk-web/cityInfo/cityInfo.do`
import fetch from '@/plugins/fetch'
import storage from '@/utils/localStorage'

async function getAllCityList() {
  const storageName = 'haz_all_city_list'
  const lifeCityList = storage.getItem(storageName)
  if (lifeCityList) {
    return lifeCityList
  } else {
    const res = await fetch(`//address.cekid.com/addressview/GetAllCityList`)
    const response = await res.json()
    if (response && response.errno == 0 && response.data) {
      let data = response.data
      console.log(data)
      storage.setItem(storageName, data, 3600 * 24)
      return data
    }
    return []
  }
}
/**
 * @returns {{cityListInitial:[],cityList:[]}}
 */
export async function getYRCityList() {
  try {
    // 暂时使用平台提供的城市列表接口
    // const res = await fetch(url)
    // const response = await res.json()
    // let cityList = []
    // console.log(response)
    // let data = response.data
    // if (response && response.errno == 0 && data) {
    //   cityList = setIndexList(data)
    // }
    const data = await getAllCityList()
    const cityList = setIndexList(data)
    return {
      cityListInitial: data,
      cityList
    }
  } catch (error) {
    throw error
  }
}

function setIndexList(data) {
  const reg = /[a-z]/g
  const cityListObj = groupBy(data, 'PINYIN', s => s[0].toUpperCase())
  const cityList = Object.keys(cityListObj).sort()
  let cityListGroup = []
  cityList.forEach(item => {
    cityListGroup.push({
      title: item,
      children: cityListObj[item]
    })
  })
  return cityListGroup
}

function push(target, k, v) {
  target[k] = target[k] || []
  target[k].push(v)
}

function groupBy(list, key, proc) {
  const res = {}
  list.sort((prev, next) => {
    if (prev[key].toUpperCase() > next[key].toUpperCase()) {
      return 1
    } else if (prev[key].toUpperCase() < next[key].toUpperCase()) {
      return -1
    } else {
      return 0
    }
  })
  list.forEach(o => {
    const k = proc ? proc(o[key]) : o[key]
    if (!k) {
      throw new Error('')
    }
    push(res, k, o)
  })
  return res
}
